<template>
  <ValidationObserver v-slot="{invalid, handleSubmit}" slim>
    <form @submit.prevent="handleSubmit(saveBonusRate)" class="justify-content-around col-lg-12">
      <div class="form-row align-items-center justify-content-center">
        <select
            class="form-group col-lg-6 col-md-12 mt-4"
            v-model="bonusType" required
            style="height: 37px">
          <option
              value="" disabled
              :selected="true">Kies een bonus type</option>
          <option :key="bonusType" v-for="bonusType in bonusTypes">
            {{ bonusType }}
          </option>
        </select>
        <NumberInputField
            labelText="percentage" class="form-group col-lg-6 col-md-12"
            max-value="100"
            min-value="0"
            v-model="percentage" required/>
      </div>
      <div class="form-row">
        <button
            type="submit" :disabled="invalid"
            class="btn-basic btn-fill-pulse">
          Opslaan
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {ValidationObserver} from "vee-validate";
import NumberInputField from "@/components/inputFields/NumberInputField";

export default {
  name: "CreateBonusRateComponent",
  components: {
    NumberInputField,
    ValidationObserver
  },
  props: ['customerId'],
  data() {
    return {
      bonusType: "",
      percentage: 0,
    };
  },
  computed: {
    ...mapGetters({
      bonusTypes: "administrationCustomer/bonusTypes"
    }),
  },
  methods: {
    ...mapActions("administrationCustomer", ['createBonusRate', 'fetchDetailsForSelectedCustomer']),
    async saveBonusRate() {
      const createBonusRateDto = {
        bonusType: this.bonusType,
        percentage: this.percentage
      };
      await this.createBonusRate(createBonusRateDto).then(() => {
        this.resetFields();
        this.fetchDetailsForSelectedCustomer();
        this.$emit('BonusRateAdded');
      });
    },
    resetFields() {
      this.bonusType = "";
      this.percentage = 0;
    },
  }
};
</script>

<style scoped>

</style>